import { IOptionsWithTypes } from "@eventr/common";
import { Stack } from "@mui/material";
import { useUserFilter } from "../hooks/useUserFilter";
import { CardText } from "../subComponents/cardText";
import { Counter } from "../subComponents/counter";
import { UsersList } from "../subComponents/usersLists";
import i18n from "i18n/i18next";
interface FlightPassengersProps {
  passengers: IOptionsWithTypes[];
  title?: string;
  showChat?: boolean;
}

export const FlightPassengers = ({ passengers, title, showChat }: FlightPassengersProps) => {
  const { filterUsers } = useUserFilter();
  const count = filterUsers(passengers).length;
  return (
    <Stack spacing="8px">
      <Stack direction="row" sx={{
        justifyContent: "space-between"
      }}>
        <CardText variant="bodyBold">{title ?? i18n.t("cards.passengers")}</CardText>
        <Counter count={count} />
      </Stack>
      <UsersList userList={passengers} showChat={showChat} />
    </Stack>
  );
};
